import React from 'react';
import PropTypes from 'prop-types';
import { Image, Menu } from 'semantic-ui-react';
import searchIcon from '../../../../assets/images/icon-search.svg';
import WelcomeName from './WelcomeName';
import MyHuddleDropdown from './MyHuddleDropdown';
import styles from './DesktopHeader.styles';

const SignedInSubMenu = ({ userName, logout }) =>
  (<Menu.Menu position="right">
    <Menu.Item style={styles.menuItem}>
      <WelcomeName text={userName} />
    </Menu.Item>
    <Menu.Item style={styles.menuItem}>
      <MyHuddleDropdown />
    </Menu.Item>
    <Menu.Item
      link
      name="signOut"
      onClick={logout}
      style={styles.menuItem}
      className=""
    >
      {'SIGN OUT'}
    </Menu.Item>
    <span style={styles.separator} />
    <Menu.Item
      link
      name="HELP"
      onClick={null /* this.handleItemClick*/}
      href="https://www.thehuddle.com/story/sports/fantasy/football/2025/05/12/help-with-the-huddle-site/83556253007/"
      style={styles.menuItem}
      className=""
    />
    {/*<Menu.Item>
      <Image
        src={searchIcon}
        style={styles.icon}
        as="a"
        href="#"
        target="_blank"
      />
    </Menu.Item>*/}
  </Menu.Menu>);

SignedInSubMenu.propTypes = {
  userName: PropTypes.string.isRequired,
  logout: PropTypes.func.isRequired,
};

export default SignedInSubMenu;



// WEBPACK FOOTER //
// ./src/app/components/Header/DesktopHeader/SignedInSubMenu.js